import React from "react";
import { Avatar, Grid, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { defaultShadowsForSignals } from "components/Signals/SignalsUtils";

interface AcxKeyInformationCardProps {
    id: any;
    title: string;
    icon: any;
    value: string | number;
    valueLabel?: string;
    label?: string | number;
    note?: string;
}

const AcxKeyInformationCard = (props: AcxKeyInformationCardProps) => {
    const theme = useTheme();
    return (
        <Grid
            container
            item
            sx={{
                borderRadius: theme.shape.borderRadius * 0.5,
                backgroundColor: theme.palette.white.main,
                minWidth: "315px",
                minHeight: "80px",
                boxShadow: defaultShadowsForSignals,
                flex: 1,
            }}
            id={props.id}
            direction={"row"}
            alignItems={"center"}
            gap={1}
            wrap="nowrap"
            padding={1}
        >
            <Grid item>
                <Avatar sx={{ bgcolor: theme.palette.primary.light }}>
                    {props.icon}
                </Avatar>
            </Grid>
            <Stack gap={1}>
                <Typography
                    variant="h3"
                    sx={{
                        color: theme.palette.text.secondary,
                    }}
                    fontWeight={600}
                    fontSize={16}
                >
                    {props.title}
                </Typography>

                <Grid
                    container
                    sx={{
                        display: "flex",
                    }}
                >
                    <Typography variant="h2" fontSize={20}>
                        {props.value}
                        {props.valueLabel}
                    </Typography>
                    {props.note && (
                        <Typography
                            variant="h3"
                            sx={{
                                color: theme.palette.text.secondary,
                                marginTop: "auto",
                                marginBottom: "2px",
                                paddingLeft: "10px",
                            }}
                            fontWeight={600}
                            fontSize={12}
                        >
                            {props.note}
                        </Typography>
                    )}
                </Grid>
            </Stack>
        </Grid>
    );
};

export default AcxKeyInformationCard;
